// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlexWrapperBeneficiaries-module__wrapper--4F0NG"};